<template>
    <div>
        <p class="has-text-grey-light">Tutorial</p>
        <h1 class="title">Quickly connect with borrowers</h1>
        <div v-if="stage === 1">
            <p>Loan requests will appear in cards like this.</p>
            <br>
            <p>Want to respond to a loan request? Press the button to make an offer. Try it out!</p>
            <br>
            <b-button @click="stage += 1" type="is-primary" outlined>Make an offer</b-button>
        </div>
        <div v-else-if="stage === 2">
            <p class="is-size-4">Connect your Messenger account</p>
            <p>When you make an offer, the borrower will be notified via Facebook Messenger.</p>
            <br>
            <b-field label="Enter your m.me link to let borrowers chat with you to discuss your loan offer">
                <b-input v-model="mme_link"></b-input>
            </b-field>
            <b-button @click="set_mmeLink">Next</b-button>
        </div>
        <div v-else-if="stage === 3">
            <p class="is-size-4">Swipe left or right to see the next loan request</p>
            <p>Works just like Tinder. Try it out: swipe left or right to dismiss this card and see loan requests!</p>
        </div>
        <br>
        <p class="is-size-7 has-text-grey-lighter">Swipe this card to skip tutorial</p>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "onboarding",
        components: {BButton},
        data() {
            return {
                stage: 1,
                mme_link: null
            }
        },
        mounted() {
            this.mme_link = localStorage.getItem('mme_link');
        },
        methods: {
            set_mmeLink() {
                localStorage.setItem('mme_link', this.mme_link);
                this.stage += 1
            }
        }
    }
</script>

<style scoped>

</style>